<template>
  <div class="tm-radio">
    <div class="tm-radio-group">
      <div
        v-for="(row, rowIndex) in horizontalRows"
        :key="rowIndex"
        class="tm-radio-row"
      >
        <label
          v-for="option in row"
          :key="option.value"
          class="tm-radio-label"
          :style="horizontalColStyle"
        >
          <span class="tm-radio-input-wrap">
            <input
              type="radio"
              :name="name"
              :value="option.value"
              :required="required"
              :disabled="disabled"
              :checked="localValue == option.value"
              @change="handleChange"
              @focus="handleFocus"
              class="tm-radio-input"
            />
            <span
              class="tm-radio-custom"
              :class="{
                'dct-fonts-radio': localValue == option.value,
                disabled: disabled,
              }"
            ></span>
          </span>
          <div v-html="option.label" class="tm-radio-text"></div>
        </label>
        <!-- 补齐空格以对齐 -->
        <template v-if="row.length < colNumber">
          <span
            v-for="n in colNumber - row.length"
            :key="'empty-' + n"
            class="tm-radio-label tm-radio-label-empty"
            :style="horizontalColStyle"
          ></span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tm-radio",
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    validation: {
      type: Array,
      default: () => [],
    },
    col: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      localValue: "",
    };
  },
  computed: {
    colNumber() {
      // 默认1列
      const c = parseInt(this.col);
      return c > 0 ? c : this.options.length;
    },
    horizontalRows() {
      // 按col分组
      const rows = [];
      const col = this.colNumber;
      for (let i = 0; i < this.options.length; i += col) {
        rows.push(this.options.slice(i, i + col));
      }
      return rows;
    },
    horizontalColStyle() {
      return {
        flex: `0 0 ${100 / this.colNumber}%`,
        maxWidth: `${100 / this.colNumber}%`,
      };
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(event) {
      const value = event.target.value;
      this.localValue = value;
      this.$emit("change", this.name, value);
      if (Array.isArray(this.validation)) {
        this.validation.forEach((rule) => {
          if (rule.trigger === "change") {
            this.$emit("trigger", this.name, value);
          }
        });
      }
    },
    handleFocus() {
      this.$emit("focus");
    },
  },
};
</script>

<style scoped>
.tm-radio {
  width: 100%;
}
.tm-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tm-radio-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
}
.tm-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  position: relative;
  user-select: none;
  flex: 1;
}
.tm-radio-label-empty {
  background: none;
  border: none;
  pointer-events: none;
  flex: 0 0 auto;
}
.tm-radio-input-wrap {
  display: inline-flex;
  align-items: center;
}
.tm-radio-input {
  /* 隐藏原生radio */
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  left: 0;
}
.tm-radio-custom {
  width: 16px;
  height: 16px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  position: relative;
  box-sizing: border-box;
  color: #409eff;
}

.tm-radio-custom.disabled {
  background: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}
.tm-radio-text {
  text-align: left;
  display: inline;
}
.tm-radio-label input[type="radio"]:disabled ~ .tm-radio-text {
  color: #bbb;
  cursor: not-allowed;
}
</style>
